import React, { useState, useEffect } from 'react';
import { useToast } from '../../../Toaster/ToastContext';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { apiClient } from '../../../services/apiClient';

const AddVariant = ({ variant, onSave }) => {
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [valueInputs, setValueInputs] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        value: [],
        status: 'active',
    });
    const [permissions, setPermissions] = useState({
        create: false,
        read: false,
        update: false,
        delete: false,
    });

    useEffect(() => {
        const storedPermissions = localStorage.getItem("rolespermissions");
        let parsedPermissions = [];
        try {
            const Permissions = JSON.parse(storedPermissions);
            const getPermissions = JSON.parse(Permissions.permissions)
            if(getPermissions.permissions){
                parsedPermissions = getPermissions.permissions;
            }
            else {
                parsedPermissions = getPermissions;
            }
        
            const inventoryPermissions = parsedPermissions.find(
                (item) => item.title === "Inventory"
            );

            const productPermissions = inventoryPermissions?.childPage?.find(
                (child) => child.title === "Variant Attributes"
            );
            // console.log("search product", productPermissions)

            if (productPermissions) {
                setPermissions({
                    create: productPermissions.create || false,
                    read: productPermissions.read || false,
                    update: productPermissions.update || false,
                    delete: productPermissions.delete || false,
                });
            } else {
                console.error("Product permissions not found in localStorage");
                showToast("Product permissions not found.", "error", "Permissions Error");
            }
        } catch (error) {
            console.error("Error parsing permissions from localStorage:", error);
            showToast("Failed to load permissions.", "error", "Permissions Error");
        }
    }, []);

    useEffect(() => {
        if (variant) {
            try {
                let values = [];
                if (Array.isArray(variant.value)) {
                    values = [...variant.value]; 
                } 
                else if (typeof variant.value === 'string') {
                    const cleanValue = variant.value
                        .replace(/[[\]'" ]+/g, '') 
                        .split(',')
                        .map(val => val.trim()) 
                        .filter(val => val.length > 0); 
                    values = cleanValue;
                } 
                else {
                    values = [];
                }
                setFormData({
                    name: variant.name || '',
                    value: values,
                    status: variant.status || 'active',
                });
                setValueInputs(values);
                setErrors({ name: '', value: '', status: '' });
            } catch (error) {
                console.error('Error processing variant data:', error);
                setFormData({ name: '', value: [], status: 'active' });
                setValueInputs([]);
                setErrors({ name: 'Invalid variant data', value: '', status: '' });
            }
        } 
        else {
            setFormData({
                name: '',
                value: [],
                status: 'active',
            });
            setValueInputs([]);
            setErrors({ name: '', value: '', status: '' });
        }
    }, [variant]);

    const [errors, setErrors] = useState({
        name: '',
        value: '',
        status: '',
    });

    const addValueInput = () => {
        setValueInputs([...valueInputs, '']);
        setErrors((prev) => ({ ...prev, value: validateField('value', [...valueInputs, '']) }));
    };

    const validateField = (name, value) => {
        switch (name) {
            case 'name':
                return value.trim() ? '' : 'Variant Name is required';
            case 'value':
                return value.length > 0 ? '' : 'At least one value is required';
            case 'status':
                return value ? '' : 'Status is required';
            default:
                return '';
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
    };

    const validateForm = () => {
        const newErrors = {
            name: validateField('name', formData.name),
            value: validateField('value', formData.value),
            status: validateField('status', formData.status),
        };
        setErrors(newErrors);
        return !Object.values(newErrors).some((error) => error !== '');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);
            try {
                const response = await apiClient.post('/store-update-varient', {
                    ...formData,
                    ...(variant && { id: variant.id }),
                });
                const Apidata = await response;
                if (Apidata.success) {
                    onSave && onSave();
                    setFormData({ name: '', value: [], status: 'active' });
                    setValueInputs([]);
                    setErrors({ name: '', value: '', status: '' });
                    document.getElementById('add-units').querySelector('[data-bs-dismiss="modal"]').click();
                    showToast(Apidata.message, 'success', 'Variant Operation!');
                    
                }
            } catch (error) {
                setLoading(false);
                showToast(error.message || 'An unexpected error occurred: Please contact the support team.', 'error', 'Variant Operation!');
            } finally {
                setLoading(false);
            }
        }
    };

    const removeValueInput = (index) => {
        const newValueInputs = valueInputs.filter((_, i) => i !== index);
        setValueInputs(newValueInputs);
        setFormData({ ...formData, value: newValueInputs });
        setErrors((prev) => ({ ...prev, value: validateField('value', newValueInputs) }));
    };

    const handleValueChange = (index, value) => {
        const newValueInputs = [...valueInputs];
        newValueInputs[index] = value;
        setValueInputs(newValueInputs);
        setFormData({ ...formData, value: newValueInputs });
        setErrors((prev) => ({ ...prev, value: validateField('value', newValueInputs) }));
    };

    return (
        <div>
            <div className="modal fade" id="add-units">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header d-flex justify-content-between align-items-center">
                                    <div className="page-title">
                                        <h4>{variant ? 'Update Variant' : 'Create Variant'}</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="form-label">Variant</label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                placeholder="Enter variant name"
                                            />
                                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Values</label>
                                            <div>
                                                {valueInputs.length === 0 && (
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={addValueInput}
                                                        className="mb-2 fs-13 fw-medium p-2 px-3"
                                                    >
                                                        Add Value
                                                    </Button>
                                                )}
                                                {valueInputs.map((value, index) => (
                                                    <div key={index} className="d-flex align-items-center mb-2">
                                                        <input
                                                            type="text"
                                                            value={value}
                                                            onChange={(e) => handleValueChange(index, e.target.value)}
                                                            placeholder={`Enter value ${index + 1}`}
                                                            className="me-2 form-control"
                                                            name="value"
                                                        />
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => removeValueInput(index)}
                                                            className="fs-13 fw-medium p-2"
                                                        >
                                                            Remove
                                                        </Button>
                                                    </div>
                                                ))}
                                                {valueInputs.length > 0 && (
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={addValueInput}
                                                        className="mt-2 fs-13 fw-medium p-2 px-3"
                                                    >
                                                        Add Value
                                                    </Button>
                                                )}
                                                {errors.value && <div className="invalid-feedback">{errors.value}</div>}
                                            </div>
                                        </div>
                                        <div className="mb-0">
                                            <label className="form-label">Status</label>
                                            <select className={`form-select ${errors.status ? 'is-invalid' : ''}`}
                                                name="status" value={formData.status} onChange={handleInputChange}
                                            >
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                            {errors.status && <div className="invalid-feedback">{errors.status}</div>}
                                        </div>
                                        <div className="modal-footer-btn">
                                            <button
                                                type="button"
                                                className="btn btn-cancel me-2"
                                                data-bs-dismiss="modal"
                                            >
                                                Cancel
                                            </button>
                                            {(variant ? permissions.update : permissions.create) && (
                                                <button type="submit" className="btn btn-submit" disabled={loading}>
                                                    {loading ? 'Processing...' : (variant ? 'Update Variant' : 'Add Variant')}
                                                </button>
                                            )}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

AddVariant.propTypes = {
    variant: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.string),
            PropTypes.string,
        ]).isRequired,
        status: PropTypes.oneOf(['active', 'inactive', '']),
    }),
    onSave: PropTypes.func,
};

AddVariant.defaultProps = {
    variant: null,
};

export default AddVariant;
